module.exports = __webpack_public_path__ + "static/media/location.e94ce81b.svg";